module.exports = __webpack_public_path__ + "b18918f367e5a5c23c37478baa145011.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/books-blue.png
// module id = 613
// module chunks = 0